export default __webpack_public_path__ + "static/media/Thumb_affisch_modersmalsdagen.dd62699b.png";